

/**
 * @name ModeSwitcherController
 * @description Controller called to displa and manage appointment details.
 * @param {Unknown} Session Session service
 * @param {Unknown} Auth Authorization service
 * @param {Unknown} $log Angular log service
 * @param {Unknown} _ Lodash
 * @param {Unknown} $cookies Angular cookies service
 * @param {Unknown} $rootScope Angular rootScrop service
 * @param {Unknown} $state ui-router state service
 * @param {Unknown} DEFAULT_STATES Constant for state defaults
 * @param {Unknown} SWITCH_MESSAGE Constant for switch messages
 */
function StateSwitcherController(
  Session,
  Auth,
  $log,
  _,
  $cookies,
  $rootScope,
  $state,
  DEFAULT_STATES,
  SWITCH_MESSAGE
) {
  let vm = this;

  vm.$onInit = function() {
    vm.changeState = changeState;
    vm.session = Session;
    vm.modalClose = modalClose;
    vm.logout = logout;
    vm.switchToBuying = switchToBuying;
    vm.toggleModal = toggleModal;
    vm.stateSwitcherModalOpen = false;
  };

  /**
   * @name toggleModal
   * @description Function to toggle the modal depending on the number of
   * selling states and the current state of the modal. If there are no selling
   * states, then the user would already be on the buying state and we will send
   * them to their user settings.
   */
  function toggleModal() {
    if (vm.stateSwitcherModalOpen === true) {
      vm.stateSwitcherModalOpen = false;
      return;
    }

    if (vm.session.states.selling && vm.session.states.selling.length > 0) {
      vm.stateSwitcherModalOpen = true;
    } else {
      $state.go('inkfinder.collector.update');
    }
  }

  /**
   * @name changeState
   * @description Function to change states (buy/selling) and the user role
   * associated with the state
   * @param {object} activeState The selected state
   */
  function changeState(activeState) {
    vm.modalClose();
    $rootScope.$broadcast('clear-data');
    Session.setActiveState(activeState);
    $cookies.putObject('inkfinder', activeState);
    if (activeState.role === 'operator') {
      $state.go(DEFAULT_STATES.operator, {}, {reload: true});
    } else {
      $state.go(DEFAULT_STATES.artist, {}, {reload: true});
    }
  }

  /**
   * @name switchToBuying
   * @description Function to move the user to the collector's dashboard
   */
  function switchToBuying() {
    const state = {
      mode: 'buying',
      role: 'collector',
      switchMessage: SWITCH_MESSAGE.buying,
      id: 1
    };
    vm.modalClose();
    $rootScope.$broadcast('clear-data');
    Session.setActiveState(state);
    $cookies.putObject('inkfinder', state);
    $state.go(DEFAULT_STATES.buying);
  }

  /**
   * @name modalClose
   * @description Function to close the login shelf
   */
  function modalClose() {
    vm.stateSwitcherModalOpen = false;
  }

  /**
   * @name logout
   * @description Wrapper for the Auth logout function
   */
  function logout() {
    vm.modalClose();
    Auth.logout();
  }
}

angular
  .module('inkfinder')
  .controller('StateSwitcherController', StateSwitcherController);



// WEBPACK FOOTER //
// ./components/auth/state-switcher/state-switcher.controller.js